import axios from "axios";

const cigamWebApi = axios.create({
  baseURL: localStorage.getItem("URLINTEGRATION"),
});

export default cigamWebApi;
